export default "__VITE_ASSET__2acab4b4__"